import { useOutletContext } from "react-router-dom";
import { Product } from "@/types";

export interface ProductDetailOutletContext {
  productDetail: Product;
}

export function useProductDetailContext() {
  return useOutletContext<ProductDetailOutletContext>();
}
